import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDPVhWIqvpdumYi6OVeLLHjafWW-FbSmKU",
  authDomain: "bicycle-3bb3d.firebaseapp.com",
  projectId: "bicycle-3bb3d",
  storageBucket: "bicycle-3bb3d.appspot.com",
  messagingSenderId: "795584438953",
  appId: "1:795584438953:web:f65ee6268cb4bdd6bc3fb8"
};

export default firebaseConfig;
